import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appAppNoSpaces]',
    standalone: false
})
export class AppNoSpacesDirective {
  private wordEntered = false;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;

    if (!this.wordEntered) {
      // If no word has been entered yet, check if the input starts with a space
      if (inputValue.startsWith(' ')) {
        // Clear leading space
        (event.target as HTMLInputElement).value = inputValue.trimLeft();
      } 
      // else {
      //   // Word has been entered
      //   this.wordEntered = true;
      // }
    }
  }

}
